function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Location from '../geom/Location';
import Label from './Label';
import GraphComponent from './GraphComponent';
var Node = /*#__PURE__*/function (_GraphComponent) {
  function Node() {
    var _this;
    _classCallCheck(this, Node);
    _this = _callSuper(this, Node);
    Node.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(Node, _GraphComponent);
  return _createClass(Node, [{
    key: "isIncidentEdgeInResult",
    value: function isIncidentEdgeInResult() {
      for (var it = this.getEdges().getEdges().iterator(); it.hasNext();) {
        var de = it.next();
        if (de.getEdge().isInResult()) return true;
      }
      return false;
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._label.getGeometryCount() === 1;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println('node ' + this._coord + ' lbl: ' + this._label);
    }
  }, {
    key: "computeIM",
    value: function computeIM(im) {}
  }, {
    key: "computeMergedLocation",
    value: function computeMergedLocation(label2, eltIndex) {
      var loc = Location.NONE;
      loc = this._label.getLocation(eltIndex);
      if (!label2.isNull(eltIndex)) {
        var nLoc = label2.getLocation(eltIndex);
        if (loc !== Location.BOUNDARY) loc = nLoc;
      }
      return loc;
    }
  }, {
    key: "setLabel",
    value: function setLabel() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && Number.isInteger(arguments[0])) {
        var argIndex = arguments[0];
        var onLocation = arguments[1];
        if (this._label === null) {
          this._label = new Label(argIndex, onLocation);
        } else this._label.setLocation(argIndex, onLocation);
      } else return _superPropGet(Node, "setLabel", this, 1).apply(this, arguments);
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "mergeLabel",
    value: function mergeLabel() {
      if (arguments[0] instanceof Node) {
        var n = arguments[0];
        this.mergeLabel(n._label);
      } else if (arguments[0] instanceof Label) {
        var label2 = arguments[0];
        for (var i = 0; i < 2; i++) {
          var loc = this.computeMergedLocation(label2, i);
          var thisLoc = this._label.getLocation(i);
          if (thisLoc === Location.NONE) this._label.setLocation(i, loc);
        }
      }
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.insert(e);
      e.setNode(this);
    }
  }, {
    key: "setLabelBoundary",
    value: function setLabelBoundary(argIndex) {
      if (this._label === null) return null;
      var loc = Location.NONE;
      if (this._label !== null) loc = this._label.getLocation(argIndex);
      var newLoc = null;
      switch (loc) {
        case Location.BOUNDARY:
          newLoc = Location.INTERIOR;
          break;
        case Location.INTERIOR:
          newLoc = Location.BOUNDARY;
          break;
        default:
          newLoc = Location.BOUNDARY;
          break;
      }
      this._label.setLocation(argIndex, newLoc);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Node;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(GraphComponent);
export { Node as default };
Node.constructor_ = function () {
  this._coord = null;
  this._edges = null;
  var coord = arguments[0];
  var edges = arguments[1];
  this._coord = coord;
  this._edges = edges;
  this._label = new Label(0, Location.NONE);
};